import { GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UI'

import {
  CartesianGrid,
  ResponsiveContainer,
  Scatter,
  ScatterChart,
  Tooltip,
  XAxis,
  YAxis,
  ZAxis
} from 'recharts'

import CustomLabelX from './CustomLabelX'
import CustomLabelY from './CustomLabelY'
import CustomTickX from './CustomTickX'
import CustomTickY from './CustomTickY'
import CustomTooltip from './CustomTooltip'

export default function CustomScatterChart({ data, kolesaData }) {
  let scatterData01 = []
  let scatterData02 = []

  scatterData01 = kolesaData
    .map(item => ({
      offerPrice: parseFloat((item.offerPrice / 1_000_000).toFixed(2)),
      mileage: parseInt(item.mileage?.slice(0, -3).replace(/\s/g, '') / 1000),
      name: 'Авто на рынке'
    }))
    .sort((a, b) => (a.mileage > b.mileage ? 1 : -1))

  scatterData02 = [
    {
      offerPrice: parseFloat((data.price / 1_000_000).toFixed(2)),
      mileage: data.mileage / 1000,
      name: 'Мое авто'
    }
  ]

  return (
    <ResponsiveContainer width="100%" height={400}>
      <ScatterChart
        width={500}
        height={200}
        margin={{ top: 20, bottom: 20, right: 10 }}
      >
        <CartesianGrid stroke={GRAY_COLORS[200]} />

        <XAxis
          label={<CustomLabelX value="Пробег, тыс. км" />}
          dataKey="mileage"
          type="number"
          tick={<CustomTickX />}
          tickLine={false}
          axisLine={false}
        />

        <YAxis
          label={<CustomLabelY value="Цена, млн ₸" />}
          dataKey="offerPrice"
          type="number"
          domain={['dataMin', 'dataMax']}
          tick={<CustomTickY />}
          tickLine={false}
          axisLine={false}
        />

        <ZAxis range={[100, 100]} />

        <Tooltip content={<CustomTooltip />} />

        <Scatter data={scatterData01} fill={PRIMARY_COLORS[300]} />
        <Scatter data={scatterData02} fill={PRIMARY_COLORS[600]} />
      </ScatterChart>
    </ResponsiveContainer>
  )
}
